import type { PluginOption } from 'vite';
import { CliError, CliErrorCode } from '@wix/cli-error';
import { generateHostCert } from '@wix/cli-ssl';

export function ssl(): PluginOption {
  return {
    name: 'wix:ssl',
    config: async (config) => {
      try {
        const certificate = await generateHostCert();

        return {
          ...config,
          server: {
            https: certificate,
          },
          preview: {
            https: certificate,
          },
        };
      } catch (err) {
        throw new CliError({
          code: CliErrorCode.FailedToGenerateSelfSignedCertificate(),
          cause: err,
        });
      }
    },
    async configureServer(server) {
      server.middlewares.use('/redirect', async (req, res) => {
        const url = new URL(req.url ?? '/', 'https://wix.com');
        const redirectUrl = url.searchParams.get('url');

        if (!redirectUrl) {
          res.statusCode = 400;
          return res.end('missing `url` query parameter');
        }

        res.statusCode = 301;
        res.setHeader('Location', redirectUrl);
        res.end(redirectUrl);
      });
    },
  };
}
